import { auditLogsEntryPoint } from '@jira/admin-pages__audit-logs/src/auditLogsEntryPoint.entrypoint.tsx';

import { adminPagesAuditLogsRoute } from '@jira/router-routes__admin-pages-audit-logs-routes/src/adminPagesAuditLogsRoute.tsx';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import type { Route } from '@atlassian/react-resource-router/src/common/types';
// eslint-disable-next-line jira/import/file-extension-required
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import { fg } from '@atlassian/jira-feature-gating';
import { auditLogsLayout } from './auditLogsLayout.tsx';

const adminPagesAuditLogsPageEntryPoint = createPageEntryPoint({
	main: auditLogsEntryPoint,
});

export const adminPagesAuditLogsRouteEntry: Route = createEntry(adminPagesAuditLogsRoute, () => ({
	group: 'global-settings',
	layout: auditLogsLayout,

	navigation: {
		sidebarId: SidebarIdGlobalSystemSettings,
		menuId: MenuIdSettings,
	},

	resources: [...getNavigationResources(), navigationSidebarGlobalResource],

	entryPoint: () => {
		return fg('jira_frontend_eal_admin_audit_log')
			? adminPagesAuditLogsPageEntryPoint
			: notFoundPageEntrypoint;
	},
	bifrost: {
		bifrostGroup: 'shell-only',
		bundling: {
			packageName: '@jira/router-routes__admin-pages-audit-logs-entries',
			whichExportToUse: 'adminPagesAuditLogsRouteEntry',
		},
		enabled: true,
	},
}));
